/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => {
    const { typography, breakpoints: { maxWidth } } = theme;
    return {
        zodiacCollection: {
            '&.center-alignment': {
                textAlign: 'center',
            },
            '&.title-container': {},
            '&.title': {
                textTransform: 'uppercase',
                fontSize: '3.75rem',
                fontFamily: typography.secondaryFontFamily,
                marginBottom: '0',
                marginTop: '1rem',
                lineHeight: '1.2',
            },
            '&.date': {
                fontWeight: '600',
                marginBottom: '0.9rem',
                marginTop: 0,
                [theme.breakpoints.down('md')]: {
                    fontSize: 'small',
                    marginBottom: '0rem',
                    marginTop: '-0.5rem',
                },
            },
            '&.description': {
                marginBottom: '2rem',
                textAlign: 'center',
                width: '100%',
                fontSize: '1.125rem',
                [theme.breakpoints.down('md')]: {
                    marginBottom: '1rem',
                },
            },
            '& .read-more-target': {
                opacity: '0',
                maxHeight: '0',
                fontSize: '0',
                transition: '0.25s ease',
            },
        },
        [theme.breakpoints.down(maxWidth.medium_screen_down)]: {
            zodiacCollection: {
                '& .read-more-state': {
                    opacity: '0',
                    '&:checked': {
                        '& ~': {
                            '& .read-more-wrap': {
                                '& .read-more-target': {
                                    opacity: '1',
                                    fontSize: 'inherit',
                                    maxHeight: '999em',
                                },
                            },
                            '& .read-more-trigger': {
                                marginTop: '10px',
                                '&::before': {
                                    content: '"Read Less"',
                                    borderBottom: '1px solid #000',
                                },
                            },
                        },
                    },
                    '& ~': {
                        '& .read-more-trigger': {
                            '&::before': {
                                content: '"Read More"',
                                borderBottom: '1px solid #000',
                            },
                        },
                    },
                },
                '& .read-more-trigger': {
                    cursor: 'pointer',
                    display: 'block',
                    padding: '0 0.5em',
                    color: '#000',
                    fontSize: '0.9em',
                    lineHeight: '2',
                    fontWeight: '700',
                    textAlign: 'center',
                    letterSpacing: '0.1em',
                },
            },
        },
    };
});

export default styles;
